module.exports = __webpack_public_path__ + "components/icon/static/moonset-842dde8397ba350a400595e3af60515f.svg";